import './header.scss';
import LogoImg from './logo-img';

const Header = () => {
    return <header className="header">
        <LogoImg className='header-image' />
    </header>
}
export default Header;
